const state = {
	startATSJobPoolOverviewTour: false,
    startATSJobPoolApplicationsTour: false,
    startATSJobPoolJobPreferencesTour: false,
    startATSJobPoolJobTeamTour: false,
    startKanbanTour: false,
	startDashboardTour: false,
	startApplicantOverviewTour: false,
	startApplicantProfileTour: false,
	startApplicantTour: false,
    isStartTourButtonClicked: false,
    startAuditTrailTour: false,
    startPermissionListingTour: false,
    startInterviewNoteListingTour: false,
    startCreateOrEditInterviewNoteTour: false,
    startCreateOrEditPermissionTour: false,
    startAssessmentTour: false,
}

const mutations = {
	SET_ATS_OVERVIEW_TOUR(state, value){
		state.startATSJobPoolOverviewTour = value
	},
	SET_ATS_APPLICATIONS_TOUR(state, value){
		state.startATSJobPoolApplicationsTour = value
	},
	SET_AUDIT_TRAIL_TOUR(state, value){
		state.startAuditTrailTour = value
	},
	SET_PERMISSION_LISTING_TOUR(state, value){
		state.startPermissionListingTour = value
	},
	SET_CREATE_OR_EDIT_PERMISSION_TOUR(state, value){
		state.startCreateOrEditPermissionTour = value
	},
	SET_ASSESSMENT_TOUR(state, value){
		state.startAssessmentTour = value
	},
	SET_INTERVIEW_NOTE_LIST_TOUR(state, value){
		state.startInterviewNoteListingTour = value
	},
	SET_CREATE_OR_EDIT_INTERVIEW_NOTE_TOUR(state, value){
		state.startCreateOrEditInterviewNoteTour = value
	},
	SET_ATS_PREFERENCES_TOUR(state, value){
		state.startATSJobPoolJobPreferencesTour = value
	},
	SET_ATS_JOB_TEAM_TOUR(state, value){
		state.startATSJobPoolJobTeamTour = value
    },
	SET_ATS_KANBAN_TOUR(state, value) {
		state.startKanbanTour = value
	},
	SET_DASHBOARD_TOUR(state, value) {
		state.startDashboardTour = value
	},
	SET_APPLICANT_OVERVIEW_TOUR(state, value) {
		state.startApplicantOverviewTour = value
	},
	SET_APPLICANT_PROFILE_TOUR(state, value) {
		state.startApplicantProfileTour = value
	},
	SET_APPLICANT_TOUR(state, value) {
		state.startApplicantTour = value
	},
    SET_START_TOUR_BUTTON(state, value) {
        state.isStartTourButtonClicked = value
    }
}

const TourGuideStore = {
	state,
	mutations
}

export default TourGuideStore
